<template>
  <div class="d-flex justify-content-between align-items-center mb-2">
    <div class="d-flex align-items-center flex-1">
      <div class="mark-severity" :class="severity"></div>
      <span>{{ $ml.get(severity) }}</span>
    </div>
    <div class="flex-1 text-center">
      <span>
        {{
          currency === "USDT"
            ? $utils.convertDollar(bounty ?? 0)
            : $utils.convertMoney(bounty ?? 0)
        }}
      </span>
    </div>
    <div class="flex-1 text-center">
      <span  style="color: #730ba9">
        {{
          currency === "USDT"
            ? $utils.convertDollar(doubleBounty ?? 0)
            : $utils.convertMoney(doubleBounty ?? 0)
        }}
      </span> 
    </div>
  </div>
</template>
<script>
export default {
  name: "ListBounty",
  props: ["severity", "bounty", "doubleBounty",],
  data() {
    return {
      currency: "BRL",
    };
  },
  mounted() {
    this.currency = this.$store.getters["getUser"]?.currency;
  },
};
</script>
<style scoped>
.flex-1 {
  flex: 1;
}

.mark-severity {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 5px;
}

.low {
  background-color: #f1f1f1;
  border: 1px solid #e1e1e1;
}
.medium {
  background-color: #fff7da;
  border: 1px solid #ffc840;
}
.high {
  background-color: #fec5b0;
  border: 1px solid #df3e03;
}
.critical {
  background-color: #c6a5f3;
  border: 1px solid rgba(154, 80, 189, 0.6274509804);
}
span {
  font-size: 14px;
  font-weight: 400;
}
</style>
